/**
 * @generated SignedSource<<a46219772ea39c996b476dadd8fefde7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RestartContentNodeAfterPassedInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterPassedMutation$variables = {
  input: RestartContentNodeAfterPassedInput;
};
export type NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterPassedMutation$data = {
  readonly LearnV2: {
    readonly restartContentNodeAfterPassed: {
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterPassedMutation = {
  response: NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterPassedMutation$data;
  variables: NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterPassedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "RestartContentNodeAfterPassedPayload",
        "kind": "LinkedField",
        "name": "restartContentNodeAfterPassed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterPassedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterPassedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f9ea48bef085d0725a83d6b1ce4c1aa9",
    "id": null,
    "metadata": {},
    "name": "NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterPassedMutation",
    "operationKind": "mutation",
    "text": "mutation NavigateDirectToQuestionsAdvanceContentButton_RestartContentNodeAfterPassedMutation(\n  $input: RestartContentNodeAfterPassedInput!\n) {\n  LearnV2 {\n    restartContentNodeAfterPassed(input: $input) {\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "56873753905c740628f94724ec52fce8";

export default node;
